import Vue from 'vue';
import VueSegmentAnalytics from 'vue-segment-analytics';

export default ({ app, store }) => {
  Vue.use(VueSegmentAnalytics, {
    id: process.env.SEGMENT_APP_ID,
    router: app.router,
  });

  const debugAnalytics = {};
  const methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
  ];

  methods.forEach(
    (method) =>
      (debugAnalytics[method] = (...args) =>
        // eslint-disable-next-line no-console
        console.info(`analytics.${method}`, ...args))
  );

  Object.defineProperty(Vue, '$analytics', {
    get() {
      return process.env.NODE_ENV === 'production' && !store.state.masquerading
        ? window.analytics
        : debugAnalytics;
    },
  });

  Object.defineProperty(Vue.prototype, '$analytics', {
    get() {
      return process.env.NODE_ENV === 'production' && !store.state.masquerading
        ? window.analytics
        : debugAnalytics;
    },
  });
};
